// npm install react-router-dom
// npm install dotenv

// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import { Routes, Route, useLocation } from 'react-router-dom';

import './App.css'

import Menu from "./Menu";

import LoginPage from "./Login";
import MessagePage from './Message';
import ConfigPage from './Configuration';
import UserPage from './User';
import StatsPage from './Statistics';
import RemotePage from './Remote';

function App() {

  const location = useLocation();
  const hideMenuRoutes = ['/', '/login'];
  const shouldHideMenu = hideMenuRoutes.includes(location.pathname);

  return (

    <div className="app-container">

        {!shouldHideMenu && <Menu />}

        <div className="content">
            <Routes>
                <Route path="/"              element={<LoginPage />} />
                <Route path="/login"         element={<LoginPage />} />
                <Route path="/message"       element={<MessagePage />} />
                <Route path="/configuration" element={<ConfigPage />} />
                <Route path="/user"          element={<UserPage />} />
                <Route path="/stats"         element={<StatsPage />} />
                <Route path="/remote"         element={<RemotePage />} />
            </Routes>
        </div>
    </div>

  )
}

export default App
